import { Video, VideoOff } from "lucide-react";

export const RawPanel = ({ localVideoRef, isLive, isConnecting, orientation }) => (
    <div className="border border-white/10 bg-surface">
        <div className="flex items-center justify-between px-4 py-3 border-b border-white/10">
            <div className="flex items-center gap-2">
                <Video className="w-3.5 h-3.5 text-white/60" />
                <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/60">
                    RAW · Webcam
                </span>
            </div>
            <span
                className={`font-mono text-[10px] uppercase tracking-[0.2em] px-2 py-0.5 border ${
                    isLive
                        ? "border-blaze/40 text-blaze bg-blaze/10"
                        : "border-white/10 text-white/40"
                }`}
            >
                {isLive ? "● LIVE" : "○ IDLE"}
            </span>
        </div>
        <div className="aspect-video bg-black relative overflow-hidden">
            <video
                ref={localVideoRef}
                autoPlay
                playsInline
                muted
                className={`w-full h-full ${orientation === "portrait" ? "object-contain" : "object-cover"}`}
                data-testid="local-video"
            />
            {!isLive && !isConnecting && (
                <div className="absolute inset-0 flex flex-col items-center justify-center text-white/30 font-mono text-xs uppercase tracking-[0.25em] gap-2">
                    <VideoOff className="w-8 h-8" />
                    Camera offline
                </div>
            )}
        </div>
    </div>
);
